/*
  Kappesberg AR — correcciones globales para todos los carruseles Splide del tema.
  (Port de assets/uz-splide-fix.js de la UZ v16.)
  Se carga como module justo después de splide-*.js y antes de Alpine (index-*.js)
  desde snippets/cruz.liquid (lo incluye el layout), así que aplica a todo `new Splide(...).mount()` de las
  secciones y de las tarjetas.

  1) "Imagen partida con la siguiente": Splide posiciona la lista en PIXELES y solo
     recalcula con el evento `resize` de la VENTANA. Cuando solo cambia el ancho del
     contenedor (aparece la barra de scroll, CSS/fuente tardía, carrusel montado
     oculto, tarjeta reemplazada al cambiar de color) la lista se queda con el
     desplazamiento viejo. Un ResizeObserver en el root dispara `resize` en el propio
     Splide, que solo rehace el layout si el tamaño del track cambió de verdad.

  2) "Imagen que no carga / tarda": las imágenes de los slides fuera de pantalla son
     loading="lazy", y el lazy nativo no carga lo que está recortado por el
     overflow:hidden del track. Cuando el carrusel está cerca del viewport, las
     imágenes de la página actual y de la vecina pasan a eager.
     OJO (lección de la UZ): en el mini-carrusel de fotos de la TARJETA eso NO se hace
     al entrar en pantalla — en una grilla de 48 tarjetas precargar las fotos ocultas
     compite con la foto principal y la grilla queda MÁS lenta. Ahí solo se precarga
     cuando la persona muestra interés (hover, touch o foco).

  3) Videos con autoplay / data-kp-autoplay (snippets/card-video.liquid): reproduce el
     del slide visible y pausa los demás, solo mientras el carrusel está en pantalla.
*/
(function () {
  var Splide = window.Splide
  if (!Splide || Splide.prototype.__kpFix) return
  Splide.prototype.__kpFix = true

  var mount = Splide.prototype.mount

  function isAlive(splide) {
    return splide.root && splide.root.isConnected && splide.root.classList.contains('is-initialized')
  }

  function watchResize(splide) {
    if (!('ResizeObserver' in window)) return
    // ResizeObserver ya agrupa por frame; el Layout de Splide ignora si el tamaño no cambió.
    var observer = new ResizeObserver(function () {
      if (isAlive(splide)) splide.emit('resize')
    })
    observer.observe(splide.root)
  }

  function preloadNearby(splide) {
    var visible = false

    function run() {
      if (!visible || !isAlive(splide)) return
      var total = splide.length
      if (!total) return
      var perPage = splide.options.perPage || 1
      var radius = Math.ceil(perPage) // una página de cada lado
      var current = splide.index

      splide.Components.Slides.get().forEach(function (slide) {
        var distance = Math.abs(slide.index - current)
        if (splide.options.type === 'loop') distance = Math.min(distance, total - distance)
        if (distance > radius) return
        slide.slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          // Carrusel anidado (tarjeta dentro del carrusel de productos): solo la foto que
          // la tarjeta está mostrando; las ocultas quedan a cargo de la propia tarjeta.
          var owner = img.closest('.splide')
          if (owner !== splide.root) {
            var inner = img.closest('.splide__slide')
            if (!inner || !inner.classList.contains('is-active') || inner.classList.contains('splide__slide--clone')) return
          }
          img.loading = 'eager'
        })
      })
    }

    splide.on('mounted move resized', run)

    // Mini-carrusel de fotos de la tarjeta: solo precarga con intención del usuario.
    if (splide.root.closest('.product-card')) {
      var onIntent = function () {
        visible = true
        run()
      }
      ;['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
        splide.root.addEventListener(type, onIntent, { once: true, passive: true })
      })
      return
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[entries.length - 1].isIntersecting
          run()
        },
        { rootMargin: '400px 0px' }
      ).observe(splide.root)
    } else {
      visible = true
    }
  }

  var VIDEO_SELECTOR = 'video[autoplay], video[data-kp-autoplay]'

  function syncVideos(splide) {
    var root = splide.root
    if (!root.querySelector(VIDEO_SELECTOR)) return
    var onScreen = false

    function run() {
      if (!root.isConnected) return
      // Tarjeta con una sola media se monta con destroy:true (sin carrusel): el único slide cuenta como visible.
      var mounted = root.classList.contains('is-initialized')
      root.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
        // el carrusel de productos contiene los carruseles de las tarjetas: cada uno cuida los suyos
        if (video.closest('.splide') !== root) return
        var slide = video.closest('.splide__slide')
        var show = onScreen && (!mounted || (slide && slide.classList.contains('is-visible')))
        if (show) {
          if (!video.paused) return
          video.muted = true
          var playing = video.play()
          if (playing && playing.catch) playing.catch(function () {})
        } else if (!video.paused) {
          video.pause()
        }
      })
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting
          run()
        },
        { threshold: 0.25 }
      ).observe(splide.root)
    } else {
      onScreen = true
    }

    splide.on('mounted moved', run)
  }

  Splide.prototype.mount = function () {
    var alreadyMounted = this.__kpWatched
    var result = mount.apply(this, arguments)
    if (!alreadyMounted && this.root) {
      this.__kpWatched = true
      watchResize(this)
      preloadNearby(this)
      syncVideos(this)
    }
    return result
  }
})()
